import React, { Component } from 'react'
import styled from '@emotion/styled'
import Grid from 'src/components/Grid'
import Input from 'src/components/Input'
import Button from 'src/components/Button'
import Select from 'src/components/Select'
import Checkbox from 'src/components/Checkbox'
import { colors, util, typography } from 'src/styles'
import { Card } from 'src/styles/globals'
import { validateEmail, validatePhoneNumber, yearValidation } from 'src/utils/validations'

const FormWrapper = styled(Card)`
  box-shadow: none;
  background: ${ colors.lightGrey };
  width: 100%;
  ${ util.responsiveStyles('padding', 60, 40, 30, 20) }
`

const ConfirmCheckbox = styled(Checkbox)`
  align-items: flex-start;
  .label-text {
    ${ typography.bodySmall }
    color: ${ colors.lightTextColor };
  }
`

class CcpaForm extends Component {
  constructor (props) {
    super(props)
    this.submitForm = this.submitForm.bind(this)
    this.state = {
      status: '',
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      last4Ssn: '',
      accountNumber: '',
      email: '',
      phone: '',
      requestType: '',
      confirmInfo: '',
      stateOfResidency: '',
    }
  }

  handleInput = event => {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleCheckbox = event => {
    this.setState({ [event.target.name]: event.target.checked })
  }

  render () {
    const { className } = this.props
    const formSpacing = '14px'

    const {
      status,
      firstName,
      lastName,
      email,
      phone,
      dateOfBirth,
      last4Ssn,
      accountNumber,
      confirmInfo,
      requestType,
      stateOfResidency
    } = this.state

    const valid =
      firstName !== '' &&
      dateOfBirth !== '' &&
      last4Ssn !== '' &&
      accountNumber !== '' &&
      lastName !== '' &&
      email !== '' &&
      requestType !== '' &&
      stateOfResidency !== '' &&
      confirmInfo &&
      yearValidation(dateOfBirth) &&
      validateEmail(email)

    const formspreeId = 'xldeqkbg'

    return (
      <FormWrapper
        className={className}
      >
          <Grid small='[1]' rowGap='24px'>
            <div>
              <form
                onSubmit={this.submitForm}
                action={'https://formspree.io/' + formspreeId}
                method="POST"
              >
                <Grid small='[1]' rowGap={formSpacing}>
                  <Grid vAlign='top' small='[1]' medium='[1] [1]' colGap={formSpacing} rowGap={formSpacing}>
                    <div>
                      <Input
                        onChange={this.handleInput}
                        name='firstName'
                        value={firstName}
                        label='First Name'
                      />
                    </div>
                    <div>
                      <Input
                        onChange={this.handleInput}
                        name='lastName'
                        value={lastName}
                        label='Last Name'
                      />
                    </div>
                  </Grid>
                  <div>
                    <Input
                      onChange={this.handleInput}
                      name='dateOfBirth'
                      value={dateOfBirth}
                      label='Date of Birth (MM/DD/YYYY)'
                      type='text'
                      isValid={yearValidation(dateOfBirth)}
                    />
                  </div>
                  <div>
                    <Input
                      onChange={this.handleInput}
                      name='last4Ssn'
                      value={last4Ssn}
                      label='Last 4 of SSN'
                      type='text'
                    />
                  </div>
                  <div>
                    <Input
                      onChange={this.handleInput}
                      name='accountNumber'
                      value={accountNumber}
                      label='Account or Application Number'
                      type='text'
                    />
                  </div>
                  <div>
                    <Input
                      onChange={this.handleInput}
                      name='email'
                      value={email}
                      label='Email'
                      type='email'
                      isValid={validateEmail(email)}
                    />
                  </div>
                  <div>
                    <Input
                      onChange={this.handleInput}
                      name='phone'
                      value={phone}
                      label='Phone'
                      type='tel'
                      isValid={validatePhoneNumber(phone)}
                    />
                  </div>
                 <div>
                    <Select
                      onChange={this.handleInput}
                      name='stateOfResidency'
                      value={stateOfResidency}
                      label='State of Residency'
                      options={[
                        { label: 'California', value: 'CA' },
                        { label: 'Colorado', value: 'CO' },
                        { label: 'Connecticut', value: 'CT' },
                        { label: 'Delaware', value: 'DE' },
                        { label: 'Iowa', value: 'IA' },
                        { label: 'Montana', value: 'MT' },
                        { label: 'Nebraska', value: 'NE' },
                        { label: 'New Hampshire', value: 'NH' },
                        { label: 'New Jersey', value: 'NJ' },
                        { label: 'Oregon', value: 'OR' },
                        { label: 'Texas', value: 'TX' },
                        { label: 'Utah', value: 'UT' },
                        { label: 'Virginia', value: 'VA' },
                        { label: 'None of these apply', value: 'NONE' },
                      ]}
                    />
                  </div>
                  <div>
                    <Select
                      onChange={this.handleInput}
                      name='requestType'
                      value={requestType}
                      label='Request Type'
                      options={[
                        { label: 'Right to Access', value: 'rightToAccess' },
                        { label: 'Right to Know', value: 'rightToKnow' },
                        { label: 'Right to Correct', value: 'rightToCorrect' },
                        { label: 'Right to Delete', value: 'rightToDelete' },
                        { label: 'Opt-Out of Selling My Information', value: 'optOutOfSelling' },
                      ]}
                    />
                  </div>
                  <div>
                    <ConfirmCheckbox
                      name='confirmInfo'
                      value='confirmed'
                      label='I declare under penalty of perjury that I am the consumer whose personal information is the subject of this request'
                      checked={confirmInfo}
                      onChange={this.handleCheckbox}
                    />
                  </div>
                  <div style={{ paddingTop: formSpacing }}>
                    <Button
                      type='submit'
                      setTheme='mainColor'
                      disabled={!valid}
                    >
                      {status === 'SUCCESS' ? 'Thank You' : 'Submit'}
                    </Button>
                  </div>
                </Grid>
              </form>
            </div>
          </Grid>
      </FormWrapper>
    )
  }

  submitForm (ev) {
    ev.preventDefault()
    const form = ev.target
    const data = new FormData(form)
    const xhr = new XMLHttpRequest()
    xhr.open(form.method, form.action)
    xhr.setRequestHeader('Accept', 'application/json')
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return
      if (xhr.status === 200) {
        this.setState({ status: 'SUCCESS' })
        setTimeout(() => {
          this.setState({
            status: '',
            firstName: '',
            lastName: '',
            dateOfBirth: '',
            last4Ssn: '',
            accountNumber: '',
            email: '',
            phone: '',
            requestType: '',
            confirmInfo: ''
          })
          form.reset()
        }, 1000)
      } else {
        this.setState({ status: 'ERROR' })
      }
    }
    xhr.send(data)
  }
}

CcpaForm.defaultProps = {
  mediaWidth: 'normal',
  mediaPlacement: 'left'
}

export default CcpaForm
